<template>

  <div>
    <main class="solicitudcredito">
      <transition name="fade" mode="out-in">
        <Preloader v-if="fundingRequestStatus === false"></Preloader>
        <div v-if="fundingRequestStatus">
          <div class="box-funding-hero">
            <img :src="fundingRequestData.image" onerror="this.src='https://placeimg.com/375/225/tech'" class="image">
          </div>
          <div class="box-funding-content">
            <div class="container">
              <div class="row row-responsive">
                <div class="column column-xs-100 column-sm-33">
                  <CompanyLogo :object="fundingRequestData"></CompanyLogo>
                  <div class="box-detail-name" v-if="fundingRequestData.business_name">
                    <h1 class="companyname">{{ fundingRequestData.business_name }}</h1>
                  </div>
                  <div class="box-detail-amount">
                    <p class="amount" v-if="fundingRequestData.market !== 'CL'">
                      {{ formatCurrency(fundingRequestData.amount_requested) }}
                    </p>
                    <p class="amount" v-else>
                      {{ formatCurrency(fundingRequestData.amount_financed) }}
                    </p>
                    <p class="title" v-if="fundingRequestData.state === 'open'">
                      Monto a financiar
                    </p>
                    <p class="title" v-else>
                      Monto financiado
                    </p>
                    <ProgressBar :object="fundingRequestData"></ProgressBar>
                    <div class="box-social-share" v-if="fundingRequestData.state === 'open'">
                      <h4 class="title">Comparte este crédito:</h4>
                      <social-sharing inline-template
                      :url="socialShare.fundingFullUrl"
                      :title="socialShare.fundingTitle"
                      :description="socialShare.fundingDescription"
                      twitter-user="cumplo"
                      >
                        <div class="socialshare">
                          <network network="facebook">
                            <img src="/static/svg/icons_fontsawesome-facebook-official.svg" alt="Facebook">
                          </network>
                          <network network="linkedin">
                            <img src="/static/svg/icons_fontsawesome-linkedin-square.svg" alt="LinkedIn">
                          </network>
                          <network network="twitter">
                            <img src="/static/svg/icons_fontsawesome-twitter.svg" alt="Twitter">
                          </network>
                          <network network="whatsapp">
                            <img src="/static/svg/icons_fontsawesome-whatsapp.svg" alt="Whatsapp">
                          </network>
                        </div>
                      </social-sharing>
                    </div>
                  </div>
                </div>
                <div class="column column-xs-100 column-sm-33">
                  <div class="box-funding-request">
                    <p>
                      <strong class="title">ID Solicitud</strong>:
                      {{ fundingRequestData.id }}
                    </p>
                    <p>
                      <strong class="title">Tipo de producto</strong>:
                      {{ fundingRequestData.product_type }}
                    </p>
                    <p>
                      <strong class="title">Plazo</strong>:
                      {{ fundingRequestData.duration }} días
                    </p>
                    <p>
                      <strong class="title">Tasa</strong>:
                      {{ formatPercentage(fundingRequestData.rate) }}
                    </p>
                    <p>
                      <strong class="title">Respaldos</strong>:
                      {{ fundingRequestData.backups.length }}
                      <a href="#" class="icon" @click.prevent="$modal.show('funding-details-backup')"><img src="/static/svg/icons_feather-plus-circle.svg"></a>
                    </p>
                    <p>
                      <strong class="title">Fecha de publicación</strong>:
                      {{ format(fundingRequestData.publish_date, 'DD/MM/YYYY') }}
                    </p>
                    <p>
                      <strong class="title">Visto por</strong>:
                      <span>{{ fundingRequestData.views }}</span> usuario{{ fundingRequestData.views | pluralize }}
                    </p>
                    <p>
                      <strong class="title">Inversionistas</strong>:
                      {{ fundingRequestData.investors_awarded }} inversionista{{ fundingRequestData.investors_awarded | pluralize }}
                    </p>
                    <p>
                      <strong class="title">Inversiones</strong>:
                      {{ fundingRequestData.investments.length }} finalizada{{ fundingRequestData.investments.length | pluralize }}
                      <a href="#" class="icon" @click.prevent="$modal.show('funding-details-investments')" v-if="fundingRequestData.investments.length !== 0"><img src="/static/svg/icons_feather-plus-circle.svg"></a>
                    </p>
                    <div class="box-request-history">
                      <h4 class="subtitle">Historial de pago solicitante:</h4>
                      <p>
                        <strong class="title">N° de créditos o docs. pagados</strong>:
                        <span v-if="fundingRequestData.paid_credits === null">0/{{ fundingRequestData.total_credits }}</span>
                        <span v-else>{{ fundingRequestData.paid_credits }}/{{ fundingRequestData.total_credits }}</span>
                      </p>
                      <p>
                        <strong class="title">% monto pagado en plazo normal</strong>:
                        <span v-if="fundingRequestData.percentage_paid !== null">{{ formatPercentage(fundingRequestData.percentage_paid) }}</span>
                        <span v-else>-</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="column column-xs-100 column-sm-33 -background-dark">
                  <div class="box-funding-request">
                    <Simulator
                      :rate="fundingRequestData.rate"
                      :duration="fundingRequestData.duration"
                      :amountRequested="fundingRequestData.amount_requested"
                      :amountFinanced="fundingRequestData.amount_financed"
                      :status="fundingRequestData.state"
                      >
                    </Simulator>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-funding-detail" v-if="fundingRequestData.loan_description">
            <div class="container">
              <div class="row row-responsive">
                <div class="column column-sm-60">
                  <div class="funding-detail funding-detail-description" v-if="fundingRequestData.loan_description">
                    <h4 class="title">Descripción del crédito</h4>
                    <div class="description" v-html="fundingRequestData.loan_description"></div>
                    <div class="funding-detail-additional-info" v-if="fundingRequestData.destinations !== null && fundingRequestData.finnancials !== null">
                      <p>
                        <strong class="subtitle">Destino del crédito</strong>:
                        <ul>
                          <li v-for="destination in fundingRequestData.destinations" :key="destination.id">{{ destination }}</li>
                        </ul>
                      </p>
                      <p>
                        <strong class="subtitle">Factor moratorio</strong>: 1.5 x tasa ordinaria
                      </p>
                      <p>
                        <strong class="subtitle">Calificación Cumplo</strong>: {{ fundingRequestData.finnancials.cumplo_score_alphanumeric }}
                        <a href="#" class="icon" @click.prevent="$modal.show('funding-details-calificacion-cumplo')">
                          <img src="/static/svg/icons_feather-help-circle.svg">
                        </a>
                      </p>
                      <p>
                        <strong class="subtitle">Calificación numérica</strong>: {{ fundingRequestData.finnancials.cumplo_score_numeric }}
                        <a href="#" class="icon" @click.prevent="$modal.show('funding-details-calificacion-numerica')">
                          <img src="/static/svg/icons_feather-help-circle.svg">
                        </a>
                      </p>
                    </div>
                  </div>
                  <div class="funding-detail funding-detail-description" v-if="fundingRequestData.enterprise_extra_info !== null">
                    <h4 class="title">Información del solicitante</h4>
                    <div class="funding-detail-additional-info">
                      <p>
                        <strong class="subtitle">Razón social</strong>: {{ fundingRequestData.business_name }}
                      </p>
                      <p v-if="fundingRequestData.enterprise_extra_info.constitution_date !== null">
                        <strong class="subtitle">Fecha de constitución</strong>: {{ reverseBirthDate(fundingRequestData.enterprise_extra_info.constitution_date) }}
                      </p>
                      <p v-if="fundingRequestData.enterprise_extra_info.address !== null">
                        <strong class="subtitle">Domicilio fiscal</strong>: {{ fundingRequestData.enterprise_extra_info.address }}
                      </p>
                      <p v-if="fundingRequestData.enterprise_extra_info.website !== null">
                        <strong class="subtitle">Sitio web</strong>: {{ fundingRequestData.enterprise_extra_info.website }}
                      </p>
                    </div>
                  </div>
                  <div class="funding-detail funding-detail-payer">
                    <h4 class="title">Descripción de los derechos del crédito</h4>
                    <div class="description" v-html="fundingRequestData.payer_description"></div>
                    <div class="funding-detail-additional-info" v-if="fundingRequestData.bills !== null">
                      <p>
                        <strong class="subtitle">Tipo</strong>:
                        <span v-if="calculateTotalInObject(fundingRequestData.bills, 'count') === 1">Homogéneo</span>
                        <span v-else>Paquete</span>
                      </p>
                      <p>
                        <strong class="subtitle">Servicio que origina</strong>: La factura fue verificada ante el SAT manteniéndose como vigente, antes de la publicación de la oportunidad.
                      </p>
                      <p>
                        <strong class="subtitle">Monto total de facturas</strong>: {{ formatCurrency(calculateTotalInObject(fundingRequestData.bills, 'sum')) }}
                      </p>
                      <p>
                        <strong class="subtitle">Aforo</strong>: {{ formatPercentage(fundingRequestData.advance_percentage) }}
                      </p>
                      <p>
                        <strong class="subtitle">Nº Facturas</strong>: {{ calculateTotalInObject(fundingRequestData.bills, 'count') }}
                      </p>
                      <table>
                        <thead>
                           <tr>
                            <th>Nombre pagador</th>
                            <th>Suma</th>
                            <th class="-centered-info">Cantidad</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="bill in fundingRequestData.bills" :key="bill.id">
                            <td>{{ bill.payer__name }}</td>
                            <td>{{ formatCurrency(bill.sum) }}</td>
                            <td class="-centered-info">{{ bill.count }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <p>
                        <button class="button" @click="$modal.show('invoices-details')">Ver detalle de todas las facturas</button>
                      </p>
                    </div>
                  </div>
                  <div class="funding-detail funding-detail-pay">
                    <h4 class="title">Amortización del crédito</h4>
                    <div class="description" v-html="fundingRequestData.payment_description"></div>
                    <div class="funding-detail-additional-info">
                      <p>
                        <strong class="subtitle">Fecha de pago estipulada</strong>: {{ reverseBirthDate(fundingRequestData.payment_date) }}
                      </p>
                      <p>
                        <strong class="subtitle">Capital</strong>: {{ formatCurrency(fundingRequestData.simulation.simulated_net_investment) }}
                      </p>
                      <p>
                        <strong class="subtitle">Interés ordinario</strong>: {{ formatCurrency(fundingRequestData.simulation.simulated_interest) }}
                      </p>
                    </div>
                  </div>
                  <div class="funding-detail funding-detail-pay" v-if="fundingRequestData.finnancials !== null">
                    <h4 class="title">Indicadores financieros</h4>
                    <div class="funding-detail-additional-info">
                      <p>
                        <strong class="subtitle">Ingresos (año)</strong>: {{ formatCurrency(fundingRequestData.finnancials.income) }}
                      </p>
                      <p>
                        <strong class="subtitle">Capital contable</strong>: {{ formatCurrency(fundingRequestData.finnancials.accounting_capital) }}
                      </p>
                    </div>
                  </div>
                  <div class="funding-detail funding-detail-pay">
                    <h4 class="title">Factores de riesgo</h4>
                    <div class="description">
                      <p>Los factores de riesgo externos que podrían afectar la capacidad del solicitante son los propios del mercado, tales como: liquidez, regulatorios y de desempeño macroeconómico. No existe riesgo por tasa de interés ya que el préstamo se otorgará en tasa fija. La calificación de riesgo asignada con base la metodología de Cumplo se basa en información histórica, por lo cual no asume el desempeño futuro del Solicitante. No se identifican riesgos ambientales.</p>
                    </div>
                  </div>
                  <div class="funding-detail funding-detail-pay" v-if="fundingRequestData.finnancials !== null">
                    <h4 class="title">Información adicional</h4>
                    <div class="description">
                       <p>Para acceder a esta información debes confirmar con SMS, llamada o Authy desde tu celular ya guardado en tu Perfil:</p>
                       <RequestExtraInfoValidateCode :enterpriseID="fundingRequestData.enterprise_profile_id"></RequestExtraInfoValidateCode>
                    </div>
                  </div>
                  <div class="funding-detail funding-detail-pay">
                    <h4 class="title">Seguimiento de la inversión</h4>
                    <div class="description">
                      <p>El seguimiento de la inversión podrá llevarse  a cabo desde la plataforma en el módulo Panel Inversiones. Asimismo, existe un canal de comunicación a través de la cuenta de correo electrónico <a href="mailto:contacto.mx@cumplo.com">contacto.mx@cumplo.com</a>.</p>
                      <p>
                        <router-link :to="{name: 'DashboardInvestment'}" class="button button-outline">Ir a mi Panel Inversiones</router-link>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="column column-sm-40">
                  <img :src="fundingRequestData.image" onerror="this.src='https://placeimg.com/375/225/tech'" class="image">
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <modal name="funding-details-backup" class="funding-details-modal" width="80%" :maxWidth="480" :adaptive="true">
        <div class="box-funding-details">
          <h3 class="title">Respaldos:</h3>
          <ul>
            <li v-for="backup in fundingRequestData.backups" :key="backup.id">{{ backup }}</li>
          </ul>
          <a href="#" class="close" @click.prevent="$modal.hide('funding-details-backup')">
            <img alt="Ingresa" src="/static/svg/icon_fontawesome-times-circle.svg">
          </a>
        </div>
      </modal>
      <modal name="funding-details-investments" class="funding-details-modal" :scrollable="true" height="auto" width="80%" :maxWidth="480" :adaptive="true">
        <div class="box-funding-details">
          <h3 class="title">Inversiones realizadas:</h3>
          <table>
            <tr>
              <th>Fecha</th>
              <th>Monto</th>
            </tr>
            <tr v-for="investment in fundingRequestData.investments" :key="investment.id">
              <td>{{ reverseBirthDate(investment.approved_date) }}</td>
              <td>{{ formatCurrency(investment.amount) }}</td>
            </tr>
          </table>
          <a href="#" class="close" @click.prevent="$modal.hide('funding-details-investments')">
            <img src="/static/svg/icon_fontawesome-times-circle.svg">
          </a>
        </div>
      </modal>
      <modal name="want-to-invest" width="90%" :maxWidth="920" height="auto" :scrollable="true" :adaptive="true">
        <ModalInvestDetail :object="fundingRequestData"></ModalInvestDetail>
      </modal>
      <modal name="funding-details-calificacion-cumplo" class="funding-details-modal" height="auto" width="80%" :maxWidth="480" :adaptive="true">
        <div class="box-funding-details">
          <h3 class="title">Calificación cumplo:</h3>
          <p>El DAC es la calificación correspondiente al <b>D</b>eudor, <b>A</b>ctividad y <b>C</b>liente</p>
          <p><strong>Deudor:</strong><br>
            A: Empresas deudoras con aceptable calidad crediticia y facturación superior a 7,5 MM USD anual. <br><br>
            B: Empresas deudoras de sector empresarial con facturación de hasta 7.5MM USD anual. <br><br>
            C: Empresas deudoras de sector en crecimiento y con facturación de hasta 1MM USD Anual.
          </p>
          <p><strong>Actividad:</strong><br>
            A: Producto o servicio de fácil recepción y no sujeta a disputa posterior de carácter comercial. <br><br>
            B: Servicio o producto con algún grado de dificultad en la recepción o aprobación de los servicios. <br><br>
            C: Productos o servicios de difícil recepción, con posible disputa comercial.
          </p>
          <p><strong>Cliente:</strong><br>
            Calculado en base a ratios financieros y comportamiento crediticio. <br><br>
            A: Calificación interna superior a 0.75. <br><br>
            B: Calificación interna de hasta 0.75 y mayor a 0.50. <br><br>
            C: Calificación interna inferior a 0.5.
          </p>
          <a href="#" class="close" @click.prevent="$modal.hide('funding-details-calificacion-cumplo')">
            <img src="/static/svg/icon_fontawesome-times-circle.svg">
          </a>
        </div>
      </modal>
      <modal name="funding-details-calificacion-numerica" class="funding-details-modal" height="auto" width="80%" :maxWidth="480" :adaptive="true">
        <div class="box-funding-details">
          <h3 class="title">Calificación numérica:</h3>
          <p>La calificación numérica que Cumplo asigna proviene de la ponderación de la calidad de las cuentas por cobrar del cliente, su actividad, experiencia de pago y desempeño financiero. La escala va de 0 a 1 (calificación más alta), siendo la mínima aprobatoria 0.49.</p>
          <a href="#" class="close" @click.prevent="$modal.hide('funding-details-calificacion-numerica')">
            <img src="/static/svg/icon_fontawesome-times-circle.svg">
          </a>
        </div>
      </modal>
       <modal name="invoices-details" width="90%" :maxWidth="920" height="auto" :scrollable="true" :adaptive="true">
        <ModalInvoicesDetails :id="fundingRequestData.id"></ModalInvoicesDetails>
      </modal>
    </main>
  </div>

</template>

<script>

import Simulator from '@/views/requestDetail/RequestDetailSimulator'
import ModalInvestDetail
  from '@/views/requestDetail/RequestDetailModalInvestDetail'
import ModalInvoicesDetails
  from '@/views/requestDetail/RequestDetailModalInvoicesDetails'
import RequestExtraInfoValidateCode
  from '@/views/requestDetail/RequestDetailExtraInfoValidateCode'

import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

import CompanyLogo from '@/components/CompanyLogo'
import Preloader from '@/components/Preloader'
import ProgressBar from '@/components/ProgressBar'

import { format } from 'date-fns'
import SocialSharing from 'vue-social-sharing'

import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'

Vue.use(VueSweetalert2)

export default {
  name: 'Request',
  metaInfo () {
    return {
      title: `Crédito #${this.id}`
    }
  },
  components: {
    Preloader,
    ProgressBar,
    Simulator,
    ModalInvestDetail,
    SocialSharing,
    CompanyLogo,
    ModalInvoicesDetails,
    RequestExtraInfoValidateCode
  },
  filters: {
    pluralize: function (value) {
      return value === 1 ? '' : 's'
    }
  },
  mixins: [mixins, httpRequestMixin],
  data () {
    return {
      format,
      user_name: null,
      id: null,
      user_email: null,
      market: null,
      fundingRequestStatus: false,
      fundingRequestData: {},
      socialShare: {
        fundingFullUrl: window.location.protocol +
          '//' + window.location.host + this.$route.fullPath,
        fundingTitle: null,
        fundingDescription: null
      }
    }
  },
  created: async function () {
    if (this.$store.getters.getCurrentStep !== -1) {
      Vue.swal({
        type: 'warning',
        title: 'Perfil incompleto',
        text: 'Por favor completa tu perfil antes de continuar',
        showConfirmButton: true,
        confirmButtonColor: '#00ba68',
        confirmButtonText: 'Completar mi perfil',
        allowOutsideClick: false,
        onClose: () => {
          this.$router.push({ name: 'UserProfile' })
        }
      })
    }
    this.market = this.$route.params.market
    this.id = this.$route.params.id
    this.getFundingRequest(this.market, this.id)
  },
  methods: {
    calculateTotalInObject: function (object, key) {
      let initialValue = 0
      let sum = object.reduce(function (total, currentValue) {
        return total + currentValue[key]
      }, initialValue)

      return sum
    },
    getFundingRequest: async function (market, id) {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/fr/' + id + '/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.fundingRequestData = response.data

        this.socialShare.fundingTitle = `Mira este crédito
          ${this.fundingRequestData.auction_type} en Cumplo, solicitado por
          ${this.fundingRequestData.business_name} por el monto de
          ${this.formatCurrency(this.fundingRequestData.amount_requested)}`

        this.socialShare.fundingDescription = `Crédito
          #${this.$route.params.id} con plazo de
          ${this.fundingRequestData.duration} días, tasa
          ${this.formatPercentage(this.fundingRequestData.rate)}.`

        this.fundingRequestStatus = true
      }
    }
  }
}

</script>

<style lang="scss">

.description {
  margin-bottom: 1rem;
  font-size: .95em;

  p {
    margin-bottom: 1rem;
  }
}

.box-social-share {
  margin: 3rem 0;

  .title {
    border-bottom: 1px solid $grey-100;
  }

  .socialshare > span {
    cursor: pointer;
  }
}

.box-company-logo {
  margin: 2rem auto 1.5rem;
  text-align: center;
}

.funding-details-modal {
   overflow-x: scroll;

  .box-funding-details {
    padding: 2rem;
  }

  .title {
    color: $midnight-blue;
    border-bottom: 1px solid #ccc;
    font-weight: normal;
  }

  .close {
    $offset: 15px;

    position: absolute;
    top: $offset;
    right: $offset;
  }
}

</style>

<style lang="scss" scoped>

.solicitudcredito {
  min-height: 400px;

  .preloader {
    margin-top: 300px;
  }

  .box-detail-name {
    text-align: center;

    .companyname {
      font-size: 1.6rem;
    }
  }

  .box-funding-hero {
    position: relative;
    height: 15rem;
    background-position: center center;
    background-size: cover;
    overflow: hidden;

    @media (min-width: 42rem) {
      height: 25rem;
    }

    > img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      filter: blur(4px);
      object-fit: cover;
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.6);
    }
  }

  .box-funding-content {
    $offset: 6rem;

    margin-top: -$offset;

    .column {
      background-color: $white;

      &:not(:last-of-type) {
        border-bottom: 1px solid $grey;
      }

      @media (min-width: 42rem) {
        border-bottom: 0!important;
        box-shadow: 0px -5px 15px rgba(0, 0, 0, .1);
      }

      &:nth-of-type(1) {
        @media (min-width: 42rem) {
          margin-top: -$offset;
        }
        z-index: 2;
      }

      &.-background-dark {
        background-color: $midnight-blue;
      }
    }
  }

  .box-funding-detail {
    padding: 6rem 2rem;
    background-color: $grey;

    .funding-detail:not(:last-child) {
      margin-bottom: 2rem;
      border-bottom: 1px solid #ccc;
    }

    .title {
      font-size: 1.1em;
      margin-bottom: 1rem;
    }

    .description {
      margin-bottom: 1rem;
      font-size: .95em;
    }

    .image {
      border: 5px solid $white;
    }
  }

  .box-funding-request {
    padding: 3rem 2rem;

    p {
      margin-bottom: 1.5rem;
      font-size: .9em;
      line-height: 1;

      .title {
        font-weight: 500;
      }
    }

    .subtitle {
      margin-top: 3rem;
      margin-bottom: 2rem;
      font-size: 1em;
      border-bottom: 1px solid $grey-100;
    }
  }

  .box-detail-amount {
    padding: 0 1rem 3rem;

    p {
      margin-bottom: 0;
      text-align: center;
    }

    .amount {
      color: $green;
      font-weight: bold;
      font-size: 1.4em;
      margin-bottom: 0;
    }

    .title {
      font-size: .9em;
    }

    .status-bar {
      margin-top: 2rem;
    }
  }
}

.icon {

  > img {
    margin-left: 5px;
    margin-bottom: -4px;
  }
}

.funding-detail-additional-info {
  margin: 2rem 2rem 3rem;
  padding-left: 2rem;
  border-left: 4px solid #ddd;

  .subtitle {
    font-size: 1em;
  }

  ul {
    margin: 0 2rem .5rem;
  }

  p,
  li {
    margin-bottom: .5rem;
  }
}

.-less-margin {

  p,
  li {
    margin-bottom: .5rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/RequestDetail.vue